import { Cell } from "./cell.js";
import { RowSelector } from "./selectors.js";

function normalizedCellIndex(row, index) {
    let normalized = 0;
    for (let i = 0; i < index; i += 1) {
        normalized += row.cells[i].multiColumn?.columnSpan ?? 1;
    }
    return normalized;
}

export function Row({ rowIndex, row, columnSpecifications }) {
    return (
        <tr>
            <RowSelector index={rowIndex} />
            {row.cells.map((cell, cellIndex) => {
                const index = normalizedCellIndex(row, cellIndex);
                return (
                    <Cell
                        key={cellIndex}
                        cellData={cell}
                        rowIndex={rowIndex}
                        row={row}
                        columnIndex={index}
                        columnSpecification={columnSpecifications[index]}
                    />
                );
            })}
        </tr>
    );
}
